export const environment = {
  production: true,
  api: 'https://api-mairie-de-brece.agence-11h10.fr',
  url: 'https://preprod-mairie-de-brece.agence-11h10.fr'
};
